module.exports = __webpack_public_path__ + "site/img/12.21c59bcd.jpg";